export default __webpack_public_path__ + "static/portfolio-mas-6-2de3e4ad763971ebf02e317add87aeda.jpg";